import getFetchResponse, { ApiResponse } from '../get-fetch-response'

import { THRIVE_CLIENT_NAME } from '../../../config'

// platform's payload type
type AuthConfigPayload = ApiResponse & {
  id: string // company id
  emailDomains: Array<string>
  cognitoUserPoolId: string
  cognitoUserPoolClientId: string
}

type GetThriveAuthConfig = {
  (value: { email: string } | { companyHint: string }): Promise<
    AuthConfigPayload
  >
}

// https://petstore.swagger.io/?url=https://staging-api.thriveglobal.com/v1/swagger.json#/auth/post_auth_get_auth_configuration
export const getThriveAuthConfig: GetThriveAuthConfig = async (value) => {
  const body = {
    ...value,
    clientName: THRIVE_CLIENT_NAME,
  }

  // this is an unauth'd Thrive API call because this is a new user without
  // an associated Cognito user pool
  const res = await getFetchResponse<AuthConfigPayload>(
    { method: 'POST', path: '/v1/auth/get_auth_configuration', body },
    true
  )

  return res
}
